let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9k4Cl")).then(() => parcelRequire('kNZGg'));